import React from 'react';
import { Shuffle, ArrowDownAZ, CopyCheck, Trash2 } from 'lucide-react';

interface EntryToolbarProps {
  totalEntries: number;
  onShuffle: () => void;
  onSortAZ: () => void;
  onDeduplicate: () => void;
  onClearAll: () => void;
  disabled?: boolean;
}

export const EntryToolbar: React.FC<EntryToolbarProps> = ({
  totalEntries,
  onShuffle,
  onSortAZ,
  onDeduplicate,
  onClearAll,
  disabled = false,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        padding: '0.4rem 0',
        gap: '4px',
        borderBottom: '1px solid var(--border-subtle)',
      }}
    >
      <div style={{ display: 'flex', gap: '3px', flexWrap: 'wrap' }}>
        <button
          onClick={onShuffle}
          disabled={disabled || totalEntries <= 1}
          className="btn-ghost"
          style={{ fontSize: '0.75rem', padding: '4px 6px' }}
          title="Shuffle items order"
        >
          <Shuffle size={13} />
          Shuffle
        </button>

        <button
          onClick={onSortAZ}
          disabled={disabled || totalEntries <= 1}
          className="btn-ghost"
          style={{ fontSize: '0.75rem', padding: '4px 6px' }}
          title="Sort alphabetically A to Z"
        >
          <ArrowDownAZ size={13} />
          Sort A-Z
        </button>

        <button
          onClick={onDeduplicate}
          disabled={disabled || totalEntries <= 1}
          className="btn-ghost"
          style={{ fontSize: '0.75rem', padding: '4px 6px' }}
          title="Remove duplicate names"
        >
          <CopyCheck size={13} />
          De-dup
        </button>
      </div>

      <button
        onClick={() => {
          if (window.confirm('Are you sure you want to clear all entries?')) {
            onClearAll();
          }
        }}
        disabled={disabled || totalEntries === 0}
        className="btn-ghost"
        style={{ fontSize: '0.75rem', padding: '4px 6px', color: '#ef4444' }}
        title="Clear all entries"
      >
        <Trash2 size={13} />
        Clear
      </button>
    </div>
  );
};
